import { useState, useEffect } from 'react';

/**
 * Detects if the app is running as an installed PWA (standalone mode).
 * Useful for adjusting UI (hiding browser chrome hints, adjusting safe areas, etc.)
 */
export function useStandaloneMode() {
  const [isStandalone, setIsStandalone] = useState(() => {
    if (typeof window === 'undefined') return false;
    try {
      if ((navigator as any).standalone === true) return true;
      if (window.matchMedia('(display-mode: standalone)').matches) return true;
      if (window.matchMedia('(display-mode: fullscreen)').matches) return true;
    } catch {
      // ignore
    }
    return false;
  });

  useEffect(() => {
    const mql = window.matchMedia('(display-mode: standalone)');
    const handler = (e: MediaQueryListEvent) => setIsStandalone(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isStandalone;
}
